<ion-modal [isOpen]="reference" backdropDismiss="false">
  <ng-template>
    <ion-content class="ion-padding">
      @for (referenceOverlay of referenceOverlays; track referenceOverlay) {
          @if (showAllReferences) {
            @if (referenceOverlay?.title && referenceOverlay?.overlay?.content.length > 0) {
              <app-content-title [content]="referenceOverlay.title"></app-content-title>
            }
          }
          @if (referenceOverlay?.overlay?.content && referenceOverlay?.overlay?.content.length > 0) {
            <app-content-title content="{{ 'REFERENCES' | translate }}"></app-content-title>
          } 
          @for (content of referenceOverlay?.overlay?.content; track content) {
            <app-content-text [content]="content"></app-content-text>
          }
          @if (referenceOverlay?.overlay?.footnotes && referenceOverlay?.overlay?.footnotes.length > 0) {
            <app-content-title content="{{ 'FOOTNOTES' | translate }}"></app-content-title>
          }
          @for (content of referenceOverlay?.overlay?.footnotes; track content) {
            <app-content-text [content]="content"></app-content-text>
          }
          @if (referenceOverlay?.overlay?.abbreviations && referenceOverlay?.overlay?.abbreviations.length > 0) {
            <app-content-title content="{{ 'ABBREVIATIONS' | translate }}"></app-content-title>
          }
          @for (content of referenceOverlay?.overlay?.abbreviations; track content) {
            <app-content-text [content]="content"></app-content-text>
          }
          <div class="blank-div"></div>
        }
    </ion-content>
    <app-footer secondaryButtonText="CLOSE_REFERENCES" [showSecondaryButtonIcon]="true" secondaryButtonIcon="close"
      [showPrimaryButton]="false" [isTermsAndPrivacy]="true" [isReference]="true"
      (secondaryButtonClickEvent)="hideReferences()"></app-footer>
  </ng-template>
</ion-modal>
